import {Component, OnInit, ViewChild, inject} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule} from '@angular/forms';
import {MatStep, MatStepper, MatStepLabel} from '@angular/material/stepper';
import {I18nService} from '../../_services/gui/i18n.service';
import {AuthenticationService} from '../../_services/authentication.service';
import {Router} from '@angular/router';
import {first} from 'rxjs/operators';
import {ResetPasswordComponent} from '../../admin/user-admin/reset-password/reset-password.component';
import {UserDeviceAdminComponent} from '../../mfa/user-device-admin/user-device-admin.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-first-time-login',
    templateUrl: './first-time-login.component.html',
    styleUrls: ['./first-time-login.component.scss'],
    imports: [MatStepper, MatStep, ReactiveFormsModule, MatStepLabel, ResetPasswordComponent, UserDeviceAdminComponent, TranslateModule]
})
export class FirstTimeLoginComponent implements OnInit {

  termsAndConditionsFormGroup: UntypedFormGroup;
  passwordChanged: boolean = false;
  userName: string;
  authenticationService = inject(AuthenticationService);

  @ViewChild('stepper') private stepper: MatStepper;
  @ViewChild('step1') private step1: MatStep;
  @ViewChild('step2') private step2: MatStep;

  private mfaDevices: number = 0;
  private router = inject(Router);
  private formBuilder = inject(UntypedFormBuilder);
  private i18nService = inject(I18nService);

  constructor() {
    const authenticationService = this.authenticationService;

    authenticationService.userName$.pipe(first()).subscribe(userName => this.userName = userName);
  }

  ngOnInit() {

    this.i18nService.setTitle('title.getting-started');

    this.termsAndConditionsFormGroup = this.formBuilder.group({
      acceptTou: false
    });

  }

  onAgree(value: any) {
    console.debug(`Agree submit value: ${JSON.stringify(value)}`);
    this.step1.completed = value.acceptTou;
    this.stepper.next();
  }

  onPasswordChanged(successfulEdit: boolean) {
    if(successfulEdit) {
      this.passwordChanged = true;
      this.step2.completed = true;
    }
  }

  logout() {
    this.authenticationService.logout();
  }

  onMfaDevicesChanged(value: number) {
    this.mfaDevices = value;
  }

  get mfaDeviceAdded(): boolean {
    return this.mfaDevices > 0;
  }

  get firstTimeLoginCompleted(): boolean {
    return this.passwordChanged && this.mfaDeviceAdded;
  }

}

